export default class PostMod {
    constructor() {
        let dates = document.querySelectorAll('.arrow-lsat-post-list div.elementor-post__meta-data > span');

        dates.forEach(date => {
            const dateNum = date.innerText.match(/^\S+/g).join('')
            const dateMonth = date.innerText.match(/[a-zA-Z]{3}/g).join('')
            date.textContent = dateNum + ' ' + dateMonth
        })
    }
}